import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import MainButton from '../MainButton';
import useDeviceResize from '../../../hooks/useDeviceResize';
import StepNavigationAmount from '../StepNavigationAmount';

import useStyles from './makeStyles';

const StepNavigationButtons = ({
  btnText,
  isDisabled,
  amount,
  handleOpenMobileSummary,
  buttonHandler,
  iconDown,
  isFetchingPrice,
}) => {
  const classes = useStyles();
  const isDeviceLgSize = useDeviceResize('lg');

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={4} lg={6} className={classes.buttonContainer}>
        <MainButton
          variant="contained"
          onClick={buttonHandler}
          className={classes.button}
          color="primary"
          disabled={isDisabled}
        >
          {btnText}
        </MainButton>
      </Grid>
      <Grid item xs={12} md={8} lg={6} className={classes.paymentTotalContainer}>
        <Grid
          container
          alignItems="center"
          className={classes.paymentTotal}
          onClick={isDeviceLgSize ? handleOpenMobileSummary : () => { }}
        >
          <StepNavigationAmount
            amount={amount}
            iconDown={iconDown}
            isMobile={isDeviceLgSize}
            isFetchingPrice={isFetchingPrice}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

StepNavigationButtons.propTypes = {
  btnText: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  amount: PropTypes.number.isRequired,
  iconDown: PropTypes.bool,
  handleOpenMobileSummary: PropTypes.func.isRequired,
  buttonHandler: PropTypes.func.isRequired,
  isFetchingPrice: PropTypes.bool,
};

StepNavigationButtons.defaultProps = {
  iconDown: false,
  isDisabled: false,
  isFetchingPrice: false,
};

export default StepNavigationButtons;
